(function () {
  let sections = document.querySelectorAll(".section-card-review");

  sections.forEach(function (section) {
    const error = section.querySelector(".error");
    if (error) {
      const errorMessage = section.querySelector(".section-card__error");

      if (errorMessage) {
        errorMessage.style.display = "flex";
        console.log(errorMessage.nextSibling);
        errorMessage.nextElementSibling.classList.add("section-error");
        const link = errorMessage.querySelector("a");
        if (link) {
          link.addEventListener("click", function (event) {
            error.scrollIntoView();
            error.preventDefault();
          });
        }
      }
    }
  });
})();
